import React from 'react'
import PropTypes from 'prop-types'
import styles from './Avatar.module.scss'

const cx = (...p) => p.filter(Boolean).join(' ')

export const initialsFrom = name => {
  if (!name) return ''
  const parts = String(name).trim().split(/\s+/).filter(Boolean)
  if (parts.length === 0) return ''
  if (parts.length === 1) return parts[0].slice(0, 2)
  return (parts[0][0] + parts[parts.length - 1][0])
}

const Avatar = ({ name, initials, tone = 'lilac', size = 'medium', className, ...rest }) => {
  const text = initials || initialsFrom(name)
  return (
    <span
      className={cx(styles.avatar, styles[tone], styles[size], className)}

      role="img"
      aria-label={name || text}
      {...rest}
    >
      <span aria-hidden="true">{text}</span>
    </span>
  )
}

Avatar.propTypes = {
  name: PropTypes.string,
  initials: PropTypes.string,

  tone: PropTypes.oneOf(['lilac', 'operator']),
  size: PropTypes.oneOf(['small', 'medium', 'large']),
  className: PropTypes.string,
}

export default Avatar
